import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import PercentageBar from './PercentageBar'

const emailStatusColors = {
  DELIVERED: '#059669',
  WAITING: '#6b7280',
  FAILED: '#dc2626'
}

const emailStatuses = ['DELIVERED', 'WAITING', 'FAILED']

const percentLimit = 25

const EmailStatusPercentageBar = ({ emailStats }) => {
  const { t } = useTranslation()

  const [processedStatuses, setProcessedStatuses] = useState([])

  const emailStatValuesArr = Object.values(emailStats || {})
  const totalEmailCount = emailStatValuesArr.reduce((a, b) => a + b, 0)

  const getPercent = (val) => {
    const percent = val * 100 / totalEmailCount

    return percent % 1 === 0 ? percent : percent.toFixed(1)
  }

  useEffect(() => {
    const allStatusObjArr = []

    emailStatuses.forEach((item) => {
      if (emailStats?.[item]) {
        allStatusObjArr.push({
          label: t(`mailTemplate.campaigns.emailReport.${item}`),
          color: emailStatusColors[item],
          value: getPercent(emailStats[item])
        })
      }
    })

    setProcessedStatuses(allStatusObjArr)
  }, [emailStats, t])

  return (
    <div className='p-1 w-full'>
      <PercentageBar
        valueArr={processedStatuses.map((item) => item.value)}
        labelArr={processedStatuses.map((item) => item.label)}
        colorArr={processedStatuses.map((item) => item.color)}
        percentLimit={percentLimit}
        emptyLabel={t('mailTemplate.campaigns.emailReport.DELIVERED')}
        emptyColor={emailStatusColors.WAITING}
      />
    </div>
  )
}

export default EmailStatusPercentageBar
